import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const PersonInfoService = {
  async add(form,userid) {
    try {
      const result = await axios.post(`${apiUrl}/personnelInfo/`, {
        form : form ,userid:userid
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async detail(userid) {
    try {
      const result = await axios.get(`${apiUrl}/personnelInfo/personel/`+userid);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
   async famillydetail(userid) {
    try {
      const result = await axios.get(`${apiUrl}/personnelInfo/infoperson/`+userid);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
}

export default PersonInfoService;